import { Swiper } from 'swiper'
import {
  Navigation,
  Pagination,
} from 'swiper/modules'

if ($('.js-infoSlider').length > 0) {
  new Swiper('.js-infoSlider', {
    modules: [Navigation, Pagination],
    spaceBetween: 5,
    lockClass: 'is-hidden',
    pagination: {
      el: '.js-infoSliderPagination',
      type: 'fraction',
    },
    navigation: {
      nextEl: '.js-infoSliderNext',
      prevEl: '.js-infoSliderPrev',
    },
    breakpoints: {
      768: {
        spaceBetween: 11,
      },
      1024: {
        spaceBetween: 20,
      },
    },
  })
}
